import script from "./DrawingToolModeControls.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawingToolModeControls.vue?vue&type=script&setup=true&lang=js"

import "./DrawingToolModeControls.vue?vue&type=style&index=0&id=a090af2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a090af2a"]])

export default __exports__